/**
 * Purchasing-nav "Tip" badge: lit when they leave order success with a
 * waiting case unopened. Cleared on Home (purchasing) or snooze / dismiss / CTA.
 * Never a popup.
 */

const listeners = new Set()
let tipReady = false

export function isGrowthEngineHomeTipReady() {
  return tipReady
}

/**
 * @param {boolean} ready
 */
export function setGrowthEngineHomeTipReady(ready) {
  const next = Boolean(ready)
  if (next === tipReady) return
  tipReady = next
  listeners.forEach(listener => {
    try {
      listener(tipReady)
    } catch (err) {
      console.warn('Growth Engine home tip badge listener failed', err)
    }
  })
}

export function markGrowthEngineHomeTipReady() {
  setGrowthEngineHomeTipReady(true)
}

export function clearGrowthEngineHomeTipBadge() {
  setGrowthEngineHomeTipReady(false)
}

/**
 * @param {(ready: boolean) => void} listener
 * @returns {() => void}
 */
export function subscribeGrowthEngineHomeTipBadge(listener) {
  if (typeof listener !== 'function') {
    return () => {}
  }
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Test helper. */
export function __resetGrowthEngineHomeTipBadgeForTests() {
  tipReady = false
  listeners.clear()
}
